<div #postpaidContainer id="postpaid">
  <app-splash-screen-requests></app-splash-screen-requests>
  <router-outlet></router-outlet>
  <app-alert></app-alert>
</div>
